/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Gateway_Not_ConfiguredInputs */

const en_billing_gateway_not_configured = /** @type {(inputs: Billing_Gateway_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The payment gateway isn't configured yet — nothing was charged.`)
};

const id_billing_gateway_not_configured = /** @type {(inputs: Billing_Gateway_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gateway pembayaran belum dikonfigurasi — tidak ada tagihan.`)
};

/**
* | output |
* | --- |
* | "The payment gateway isn't configured yet — nothing was charged." |
*
* @param {Billing_Gateway_Not_ConfiguredInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_gateway_not_configured = /** @type {((inputs?: Billing_Gateway_Not_ConfiguredInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Gateway_Not_ConfiguredInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_gateway_not_configured(inputs)
	return en_billing_gateway_not_configured(inputs)
});